import { Outlet, NavLink, useLocation } from 'react-router-dom'
import Logo from '../Logo'

export default function Layout({ role, theme, setTheme }) {
  const loc = useLocation()

  const staffNav = [
    { to:'/students',   icon:'👥', label:'Students'   },
    { to:'/attendance', icon:'📅', label:'Attendance'  },
    { to:'/grades',     icon:'📊', label:'Exams'       },
    { to:'/homework',   icon:'📝', label:'Homework'    },
    { to:'/reports',    icon:'📈', label:'Reports'     },
    { to:'/videos',     icon:'🎬', label:'Videos'      },
  ]
  const parentNav = [
    { to:'/home',       icon:'🏠', label:'Home'        },
    { to:'/grades',     icon:'📊', label:'Exams'       },
    { to:'/attendance', icon:'📅', label:'Attendance'  },
    { to:'/homework',   icon:'📝', label:'Homework'    },
    { to:'/reports',    icon:'📈', label:'Reports'     },
    { to:'/videos',     icon:'🎬', label:'Videos'      },
  ]
  const studentNav = [
    { to:'/home',       icon:'🏠', label:'Home'        },
    { to:'/grades',     icon:'📊', label:'Exams'       },
    { to:'/attendance', icon:'📅', label:'Attendance'  },
    { to:'/homework',   icon:'📝', label:'Homework'    },
    { to:'/reports',    icon:'📈', label:'Reports'     },
    { to:'/videos',     icon:'🎬', label:'Videos'      },
  ]

  const nav = role==='parent' ? parentNav : role==='student' ? studentNav : staffNav
  const roleLabel = { teacher:'Teacher', assistant:'Assistant', parent:'Parent', student:'Student' }[role] || ''
  const roleIcon  = { teacher:'👩‍🏫', assistant:'🧑‍💼', parent:'👨‍👩‍👦', student:'🎓' }[role] || ''
  const allNav = [...nav, { to:'/settings', icon:'⚙️', label:'Settings' }]
  const curLabel = allNav.find(n => loc.pathname.startsWith(n.to))?.label || ''

  return (
    <div className="app">

      {/* ── Sidebar ── */}
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <Logo size={28} />
            <span className="sidebar-logo-text">
              A<span style={{color:'var(--c-accent)',fontWeight:400,fontSize:13}}>+</span> in Math
            </span>
          </div>
          <div className="sidebar-role">{roleIcon} {roleLabel}</div>
        </div>
        <nav className="sidebar-nav">
          {nav.map(item => (
            <NavLink key={item.to} to={item.to}
              className={({isActive}) => `sidebar-item ${isActive?'active':''}`}>
              <span className="si-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <NavLink to="/settings"
            className={({isActive}) => `sidebar-item ${isActive?'active':''}`}>
            <span className="si-icon">⚙️</span>Settings
          </NavLink>
        </div>
      </aside>

      {/* ── Main ── */}
      <div className="main">
        <header className="topbar">
          <div className="topbar-brand">
            <Logo size={24} />
            A<span style={{color:'var(--c-accent)',fontWeight:400,fontSize:12}}>+</span> in Math
            {curLabel && <span style={{color:'var(--c-text3)',fontWeight:400,fontSize:13,marginLeft:4}}>· {curLabel}</span>}
          </div>
          <div className="topbar-actions">
            <button className="icon-btn" onClick={()=>setTheme(t=>t==='light'?'dark':'light')}
              title="Toggle theme">
              {theme==='light'?'🌙':'☀️'}
            </button>
          </div>
        </header>

        <div className="page">
          <Outlet />
        </div>
      </div>

      {/* ── Bottom Nav ── */}
      <nav className="bottom-nav">
        <div className="bottom-nav-inner">
          {nav.map(item => (
            <NavLink key={item.to} to={item.to}
              className={({isActive}) => `bn-item ${isActive?'active':''}`}>
              <span className="bn-icon">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
          <NavLink to="/settings"
            className={({isActive}) => `bn-item ${isActive?'active':''}`}>
            <span className="bn-icon">⚙️</span>
            <span>Settings</span>
          </NavLink>
        </div>
      </nav>

    </div>
  )
}